export const CACHE_KEYS = {
  all: ['contracts-management'] as const,
  contract: (contractKey: unknown) => [...CACHE_KEYS.all, 'contract', contractKey] as const,
  contractDocuments: (params: unknown) => [...CACHE_KEYS.all, 'contractDocuments', params] as const,
  contractHistory: (params: unknown) => [...CACHE_KEYS.all, 'contractHistory', params] as const,
  contractPricing: (params: unknown) => [...CACHE_KEYS.all, 'contractPricing', params] as const,
  contracts: (filters: unknown) => [...CACHE_KEYS.all, 'contracts', filters] as const,
} as const;
